<template>
  <div
    class="kd-icon-toggle-button"
    :class="{ 'kd-icon-toggle-button--selected':  isSelected }"
    @click="toggle"
  >
    <img
      class="kd-icon-toggle-button__icon"
      :src="iconUrl"
    >
  </div>
</template>

<script>
export default {
  props: {
    iconFalseUrl: String,
    iconTrueUrl: String,
    trueValue: {
      default: true,
    },
    falseValue: {
      default: false,
    },
    initialValue: Boolean,
  },
  data() {
    return {
      isSelected: false,
    };
  },
  computed: {
    iconUrl() {
      return this.isSelected ? this.iconTrueUrl : this.iconFalseUrl;
    },
  },
  methods: {
    toggle() {
      this.isSelected = !this.isSelected;
      this.$emit('change', this.isSelected ? this.trueValue : this.falseValue);
    },
  },
  watch: {
    initialValue(val) {
      this.isSelected = val;
    },
  },
};
</script>

<style lang="scss">
.kd-icon-toggle-button {
  width: 30px;
  height: 30px;
  border-radius: 3px;
  background-color: #EDEDED;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;

  &--selected {
    background-color: #00A4E0;
  }
}

.kd-icon-toggle-button__icon {
  height: 16px;
}
</style>
